<template>
    <div id="app">
        <Cheader @showlogin="showlogin" v-if="!isempty"></Cheader>
        <router-view @sethftype="sethftype" @settopnav="settopnav" @hidepop="hidepop" />
        <Cfooter v-if="!isempty"></Cfooter>
        <el-dialog :visible.sync="isshowpop" v-if="isshowpop" top="0px" :show-close="showclose" :close-on-press-escape="showclose" :close-on-click-modal="showclose">
            <pop :popurl="popurl" :poptype.sync="poptype" @hidepop="hidepop"></pop>
        </el-dialog>
        <el-dialog v-if="isshowvideo && videourl" :visible.sync="isshowvideo" top="0px" class="mydialog modulewrap">
            <video :src="videourl" controls autoplay controlslist="nodownload" @contextmenu.prevent=""></video>
        </el-dialog>

        <el-dialog v-if="isshowabout" :visible.sync="isshowabout" top="0px" class="mydialogabout modulewrap">
            <div class="sdaboutwrap">
                <div class="sdaboutwrap2"></div>
                <div class="sdaboutbox">
                    <div class="sdabout">
                        <div class="sdaboutlogo">
                            <img :src="$store.state.logourl" />
                        </div>
                        <div class="sdaboutinfo">
                            <ffswiper :infolist="aboutcur.x_imglist" :options=" { 'type': 'image', 'isautoplay': false}" :indexcur.sync="aboutindex"></ffswiper>
                        </div>
                        <div class="sdaboutbtns">
                            <a href="#" @click="adboutpage(-1)"><i class="iconfont icon-diyiyebackwardfill-01"></i></a>
                            <a href="#" @click="adboutpart(-1)"><i class="iconfont icon-fenyeshangyiye1-01"></i></a>
                            <a href="#" @click="adboutpart(1)"><i class="iconfont icon-fenyexiayiye-01"></i></a>
                            <a href="#" @click="adboutpage(1)"><i class="iconfont icon-moyeforwardfill-01"></i></a>
                        </div>

                        <div class="sdtp" v-if="aboutcur.memo=='tp'"><a href="#" @click="gotp">{{$common.dicword('gototp')}}</a></div>
                    </div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import Cheader from '@/components/Cheader';
    import Cfooter from '@/components/Cfooter';
    import pop from '@/views/pop';

    export default {
        name: 'app',
        data() {
            return {
                'hftype': 1,
                'toptitle': '',
                'topnavsort': 0,
                'topcollegeid': 0,
                'isshowpop': false,
                'popurl': 'login',
                'poptype': 1,
                'showclose': false,
                'isshowvideo': false,
                'videourl': '',
                'aboutid': 0,
                'aboutkind': [],
                'isshowabout': false,
                'aboutindex': 0
            }
        },
        components: {
            Cheader,
            Cfooter,
            pop
        },
        computed: {
            aboutcur: function () {
                return this.$common.basic.fffind(this.aboutkind, 'id', this.aboutid);
            },
            isempty: function () {
                return this.$route.params.root == 'wx';
            }
        },
        /*created() {
            this.$store.dispatch('setlangdic');//异步加载字典
        },*/
        methods: {
            sethftype(v) {
                if (v != this.toptitle) {
                    this.toptitle = v;
                    this.hftype = v ? 2 : 1;
                }

            },
            settopnav(v) {
                this.topnavsort = v;
            },
            showpop() {
                this.isshowpop = true;
            },
            hidepop() {
                this.isshowpop = false;
            },
            showlogin(v) {
                this.popurl = 'login';

                this.showclose = v < 100;
                this.poptype = v;
                this.isshowpop = true;
            },
            showabout(v) {

                if (!v) {
                    v = 0;
                }
                this.aboutid = v;
                this.aboutindex = 0;

                if (!this.$common.basic.isarrayexist(this.aboutkind)) {
                    this.$common.fetch({ 'act': 'te_about' }, res => {

                        this.$common.each(res.infodata, item => {
                            item.x_imglist = [];
                            let imglist = item.imgs.split(',');
                            this.$common.each(imglist, (item2, index2) => {
                                item.x_imglist.push({ 'id': index2, 'img': item2 });
                            })
                        })
                        if (this.aboutid == 0) {
                            this.aboutid = res.infodata[0].id;
                        }
                        this.aboutkind = res.infodata;

                        this.isshowabout = true;
                    });
                }
                else {
                    this.isshowabout = true;
                }


            },
            adboutpart: function (v) {
                this.aboutindex += v;
            },
            adboutpage: function (v) {
                let caboutindex = this.aboutkind.findIndex(item => item.id == this.aboutid);
                caboutindex += v;
                if (caboutindex >= this.aboutkind.length) {
                    caboutindex = 0;
                }
                else {
                    if (caboutindex < 0) {
                        caboutindex = this.aboutkind.length - 1;
                    }
                }
                this.showabout(this.aboutkind[caboutindex].id);
            },
            gotp: function () {
                this.isshowabout = false;
                this.$router.push('/tp')
            }
        },
        mounted() {//阻止#链接
            let aprevent = (e, href) => {
                if (this.$common.basic.chempty(href)) {
                    href = '';
                }
                if (href) {
                    if (href.substring(href.length - 1) == "#") {
                        if (e.preventDefault) {
                            e.preventDefault();
                        } else {
                            e.returnValue = false;
                        }
                        //return false;
                    }
                    else {
                        let extname = href.substring(href.lastIndexOf('.')).toLowerCase();
                        if (extname == ".mp4") {
                            this.isshowvideo = true;
                            this.videourl = href;
                            if (e.preventDefault) {
                                e.preventDefault();
                            } else {
                                e.returnValue = false;
                            }
                        }
                    }
                }

            };

            document.addEventListener('click', (e) => {
                if (e.target.tagName === 'A') {
                    aprevent(e, e.target.href);
                }
                else {
                    if (e.target.parentNode.tagName === 'A') {
                        aprevent(e, e.target.parentNode.href);
                    }
                }
            });

            window.onresize = () => {
                this.$store.commit('SET_WINDOWSIZE');
            }

            let vm = this;
            window.showlogin = function (v) {
                vm.showlogin(v + 100);
            };

            window.showabout = function (id) {
                vm.showabout(id);
            };
        }
    };
</script>
